module.exports = __webpack_public_path__ + "static/media/Tooth_icon_ffa200.f12079c8.svg";